<template>
    <div class="col-xl-4 col-lg-6 col-md-12">
        <div class="card custom-profile">                 
          <div class="card-body">
            <div class="card-profile"><img class="user-img" src="@/assets/images/general-widget/user-profile.png" alt=""></div>
            <div class="text-center profile-details"><router-link to="/users/profile"> 
                <h4>Jenny Gester</h4>
                <h6>Manager</h6></router-link></div>
            <ul class="card-social">
              <li class="bg-fb"><a href="https://www.facebook.com" target="_blank" data-bs-original-title="" title=""><i class="fa fa-facebook"></i></a></li>
              <li class="bg-gplus"><a href="https://www.google.com" target="_blank" data-bs-original-title="" title=""><i class="fa fa-google-plus"></i></a></li>
              <li class="bg-twitter"><a href="https://www.twitter.com" target="_blank" data-bs-original-title="" title=""><i class="fa fa-twitter"></i></a></li>
              <li class="bg-insta"><a href="https://www.instagram.com" target="_blank" data-bs-original-title="" title=""><i class="fa fa-instagram"></i></a></li>
              <li class="bg-linkedin"><a href="https://www.linkedin.com" target="_blank" data-bs-original-title="" title=""><i class="fa fa-linkedin"></i></a></li>
            </ul>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-4 col-sm-4">
                <h6 class="font-roboto">Follower</h6>
                <h5 class="counter">9564</h5>
              </div>
              <div class="col-4 col-sm-4">
                <h6 class="font-roboto">Following</h6>
                <h5><span class="counter">49</span>K</h5>
              </div>
              <div class="col-4 col-sm-4">
                <h6 class="font-roboto">Total Post</h6>
                <h5><span class="counter">96</span>M</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
export default{
    name: 'mangerPage'
}
</script>